<div id="labels" class="tab-pane fade active in">
    <div style="width:35%;float:left;">
        <h3 class="heading4">Add New Label</h3>
        <br>
        <form #myForm2="ngForm" (submit)="LabelCreate();myForm2.reset()">
            <!-- <input name="__RequestVerificationToken" type="hidden" 
        value="7E0IdAOzLSOYlltqbWU0DRgf6vC7vclw-boALU-MfWuy5x8b0ugytn3QocTjyUmH0APOL8g4EuQx4j48Awd4Mzye1qS-XYFtQKk-KlLldn81"> -->
            <div class="form-horizontal">
                <div class="form-group">
                    <div class="col-md-10">
                        <input class="pagefield text-box single-line" id="Label_LabelName"
                            [(ngModel)]="LabelName" name="LabelName" placeholder="Enter Label Name here"
                            style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
                            type="text" value="">
                        <span class="field-validation-valid text-danger" data-valmsg-for="LabelName"
                            data-valmsg-replace="true"></span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-10">
                        <h3 style="font-size:15px;margin:10px 0!important;">Label Type</h3>
                        <select class="form-control" id="LabelTypes" [(ngModel)]="LabelType" name="LabelType"
                            style="width: 75%" (ngModelChange)="onLabelTypeChange($event)">
                            <option value="">Choose Label Type</option>
                            <option value="Input">Input</option>
                            <option value="Target">Target</option>
                            <option value="Other">Other</option>
                        </select>

                        <span class="field-validation-valid text-danger" data-valmsg-for="LabelType"
                            data-valmsg-replace="true"></span>
                    </div>
                </div>
                <div class="form-group" *ngIf="showIsNull">
                    <div class="col-md-10">
                        <h3 style="font-size:15px;margin:10px 0!important;">Is Null</h3>
                        <input data-val="true" data-val-required="The IsNull field is required."
                            htmlattributes="{ class = pagefield }" id="Label_IsNull" [(ngModel)]="IsNull"
                            name="IsNull" type="checkbox" value="true">
                        <input name="IsNull" type="hidden" value="false">
                        <br>
                        <span class="field-validation-valid text-danger" data-valmsg-for="IsNull"
                            data-valmsg-replace="true"></span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-10">
                        <h3 style="font-size:15px;margin:10px 0!important;">Associated Sector Name</h3>
                        <select class="form-control" id="Sectors" [(ngModel)]="SectorName" name="SectorName"
                            style="width: 75%">
                            <option value="">Choose Sector</option>
                            <option option *ngFor="let sec of sectorlist" value={{sec.SectorName}}>{{sec.SectorName}}
                            </option>
                        </select>
                        <span class="field-validation-valid text-danger" data-valmsg-for="Label.SectorName"
                            data-valmsg-replace="true"></span>
                    </div>
                </div>
                <br>
                <div class="form-group">
                    <div class="col-md-10">
                        <input type="submit" value="Add Label" class="btn btn-default buttonStyle">
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div style="width:55%;float:right;border-left: #eee solid 2px; min-height:600px;padding-left:30px;">
        <br>
        <br>
        <table class="table table-bordered table-hover">
            <thead>
                <colgroup>
                    <col width="25%">
                    <col width="25%">
                    <col width="25%">
                    <col width="25%">
                </colgroup>
            </thead>
            <tbody>
                <tr style="background-color:#F9f9f9;">
                    <th>
                        <div class="center"><b>Label Name</b></div>
                    </th>
                    <th>
                        <div class="center"><b>Label Type</b></div>
                    </th>
                    <th>
                        <div class="center"><b>Sector Name</b></div>
                    </th>
                    <th>
                        <div class="center"><b>Manage</b></div>
                    </th>
                </tr>
            </tbody>

            <tbody style="text-align:center;">
                <tr *ngFor="let labe of labellist">
                    <td>
                        {{labe.LabelName}}
                    </td>

                    <td>
                        {{labe.LabelType}}
                    </td>
                    <td>
                        {{labe.SectorName}}
                    </td>

                    <td>
                        <!-- <a  class="modal-link"><span class="glyphicon glyphicon-pencil" style="color:#666;"></span></a>&nbsp;&nbsp; -->
                        <a (click)="showConfirm(labe)" class="modal-link"><span class="glyphicon glyphicon-trash"
                                style="color:#666;"></span></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
